export default {
  SET_LIST(state, list) {
    state.list = [...list]
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
  SET_DEPENDENT(state, dependent) {
    state.dependent = {...state.dependent, ...dependent}
  },
  ADD_ELEMENT_TO_TOP_OF_THE_LIST(state, element) {
    state.list.unshift(element)
  },
  UPDATE_ELEMENT_IN_LIST(state, element) {
    state.list = state.list.map((e) => {
      if (e._id === element._id) {
        e = {...e, ...element}
      }
      return e
    })
  },
  DELETE_ELEMENT_IN_LIST(state, element) {
    state.list = state.list.filter((e) => e._id !== element._id)
  },
}
